module.exports = __webpack_public_path__ + "img/THB.7079e953.svg";